import lens from '@refract-ui/sc/lens';

export const PrimaryText = lens.span({ c: 'primary' })``;
